import { ButtonStyleType } from 'src/types/type';
import styled from 'styled-components';

export const InputStyled = styled.input`
  width: 100%;
  height: 60px;
  padding-left: 15px;
  font-size: 16px;
  border: 1px solid #b3b3b3;
  box-sizing: border-box;
  transition: 0.25s;
  border-radius: 5px;

  &:focus {
    background-color: #feff99;
    border-color: #1e34de;
  }
  &:disabled {
    color: #b3b3b3;
  }
`;

export const DimmedStyled = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  position: fixed;
`;
export const CustomBtn = styled.button<ButtonStyleType>`
  cursor: pointer;
  display: block;
  border: none;
  max-width: 456px;
  width: ${(props) => props.width? props.width : '100%' };
  margin: 0 auto 10px auto;
  background-color: ${props => props.disabled? '#eee':props.backgroundColor};
  //background-color: ${(props) => props.backgroundColor};
  font-size: ${props => props.fontSize};
  fontFamily: ${(props) => props.fontFamily};
  color: ${props => props.fontColor ?? '#fff'};
  font-weight: ${props => props.fontWeight ?? 0};
  border-radius: ${props => props.borderRadius};
  letter-spacing: ${props => props.letterSpacing};
  height: ${(props) => props.height? props.height : '54px'};
  line-height: 54px;
  line-height: ${(props)=>props.lineHeight ? props.lineHeight : '54px'};
  @media all and (max-width: 492px) {
    width: 93%;
  }
  > span, > a {
    text-align: center;
    color: ${(props) => props.color};
    line-height: ${(props) => props.height};
    font-family: ${(props) => props.fontFamily};
    font-size: ${(props) => props.fontSize};
  }
`